import React  from "react";
import { StyleHeroPc } from "./heroComponents";
import { StaticImage } from "gatsby-plugin-image";
import { ImageHeader, HeaderContainer, Header, Year  } from "./linkTreeComponents";
import Img from "gatsby-image"
import styled from "styled-components";


const HeroPc = (props) => {

    return (
        <>
            <StyleHeroPc>
                <div className="row">
                
                    <div className="col-image">
                        <Img fluid={props.image.childImageSharp.fluid}
                             className="image"></Img>
                    </div>

                    <div className="col-brand">

                        <div className="logo-container" style={{justifyContent: "flex-end",
                                                                marginTop: "-50px"}}>
                            <HeaderContainer>
                                <Header>
                                    <ImageHeader>
                                        <div className="logo">
                                            <StaticImage
                                                src="../images/logo-blanco.svg"
                                                width={105}
                                                height={105}
                                                quality={95}
                                                formats={["AUTO", "WEBP", "AVIF"]}
                                                alt={`Dental VIP Plan de ortodoncia ${Year}`}
                                                />
                                        </div>
                                    </ImageHeader>
                                </Header>
                            </HeaderContainer>
                        </div>

                        <div className="captions center text">
                            <h1 className="bebas" style={{justifyContent: "flex-end"}}>{props.title.text1}</h1>
                            <h1 className="bebas" style={{marginTop: "-34px"}}>{props.title.text2}</h1>

                            <div className="slogan-container text">
                                <div className="slogan">
                                    <p><i>{props.slogan}</i></p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </StyleHeroPc>
        </>
    );
};

export default HeroPc;